let routerRef = null;

const setRouterRef = (ref) => {
  routerRef = ref;
};

const getRouterRef = () => {
  return routerRef?.history;
};

export { getRouterRef, setRouterRef };
